module.exports = __webpack_public_path__ + "media/flags/ax-84b40d6b.svg";